import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    id: "services",
    class: "services"
};
const _hoisted_2 = { class: "services__header" };
const _hoisted_3 = { class: "services__headline" };
const _hoisted_4 = { class: "polaroid polaroid--left" };
const _hoisted_5 = { class: "polaroid__photo" };
const _hoisted_6 = ["src"];
const _hoisted_7 = { class: "polaroid polaroid--center" };
const _hoisted_8 = { class: "polaroid__photo" };
const _hoisted_9 = ["src"];
const _hoisted_10 = { class: "polaroid polaroid--right" };
const _hoisted_11 = { class: "polaroid__photo" };
const _hoisted_12 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ServicePair = _resolveComponent("ServicePair");
    const _directive_reveal = _resolveDirective("reveal");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("header", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.$t('services.headlinePre')) + " ", 1),
                _createElementVNode("em", null, _toDisplayString(_ctx.$t('services.headlineItalic')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('services.headlinePost')), 1)
            ])
        ])), [
            [_directive_reveal]
        ]),
        _createVNode(_component_ServicePair, {
            id: "services-manage",
            tag: _ctx.$t('services.manage.tag'),
            "title-pre": _ctx.$t('services.manage.titlePre'),
            "title-italic": _ctx.$t('services.manage.titleItalic'),
            "title-post": _ctx.$t('services.manage.titlePost'),
            intro: _ctx.$t('services.manage.intro'),
            body: _ctx.$t('services.manage.body'),
            stat: _ctx.$t('services.manage.stat'),
            "stat-label": _ctx.$t('services.manage.statLabel')
        }, {
            visual: _withCtx(() => [
                _createElementVNode("div", {
                    ref: "skeletonsHost",
                    class: _normalizeClass(["skeletons", { 'skeletons--unfolded': _ctx.unfolded }])
                }, [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("div", { class: "skeleton skeleton--ig" }, [
                            _createElementVNode("span", { class: "skeleton__logo" }, [
                                _createElementVNode("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                    "aria-hidden": "true"
                                }, [
                                    _createElementVNode("path", { d: "M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41-.56-.22-.96-.48-1.38-.9-.42-.42-.68-.82-.9-1.38-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16zM12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63c-.79.31-1.46.72-2.13 1.39C1.35 2.69.94 3.36.63 4.14.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.31.79.72 1.46 1.39 2.13.67.67 1.34 1.08 2.13 1.39.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56.79-.31 1.46-.72 2.13-1.39.67-.67 1.08-1.34 1.39-2.13.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91-.31-.79-.72-1.46-1.39-2.13-.67-.67-1.34-1.08-2.13-1.39-.76-.3-1.64-.5-2.91-.56C15.67.01 15.26 0 12 0zm0 5.84c-3.4 0-6.16 2.76-6.16 6.16s2.76 6.16 6.16 6.16 6.16-2.76 6.16-6.16S15.4 5.84 12 5.84zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm6.41-11.85c-.8 0-1.44.65-1.44 1.44 0 .8.65 1.44 1.44 1.44.8 0 1.44-.65 1.44-1.44 0-.8-.65-1.44-1.44-1.44z" })
                                ])
                            ]),
                            _createElementVNode("div", { class: "skeleton__head" }, [
                                _createElementVNode("span", { class: "skeleton__avatar" }),
                                _createElementVNode("span", { class: "skeleton__lines" }, [
                                    _createElementVNode("span", { class: "bar bar--short" }),
                                    _createElementVNode("span", { class: "bar bar--xshort" })
                                ])
                            ]),
                            _createElementVNode("div", { class: "skeleton__media" }),
                            _createElementVNode("div", { class: "skeleton__foot" }, [
                                _createElementVNode("span", { class: "bar bar--xshort" })
                            ])
                        ], -1),
                        _createElementVNode("div", { class: "skeleton skeleton--fb" }, [
                            _createElementVNode("span", { class: "skeleton__logo" }, [
                                _createElementVNode("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                    "aria-hidden": "true"
                                }, [
                                    _createElementVNode("path", { d: "M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07c0 6.02 4.39 11.02 10.13 11.93v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.69.24 2.69.24v2.97h-1.51c-1.5 0-1.96.93-1.96 1.89v2.26h3.34l-.53 3.49h-2.81V24c5.74-.91 10.13-5.91 10.13-11.93z" })
                                ])
                            ]),
                            _createElementVNode("div", { class: "skeleton__head" }, [
                                _createElementVNode("span", { class: "skeleton__avatar" }),
                                _createElementVNode("span", { class: "skeleton__lines" }, [
                                    _createElementVNode("span", { class: "bar bar--short" }),
                                    _createElementVNode("span", { class: "bar bar--xshort" })
                                ])
                            ]),
                            _createElementVNode("div", { class: "skeleton__media" }),
                            _createElementVNode("div", { class: "skeleton__foot" }, [
                                _createElementVNode("span", { class: "bar bar--mid" })
                            ])
                        ], -1),
                        _createElementVNode("div", { class: "skeleton skeleton--li" }, [
                            _createElementVNode("span", { class: "skeleton__logo" }, [
                                _createElementVNode("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                    "aria-hidden": "true"
                                }, [
                                    _createElementVNode("path", { d: "M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.36V9h3.41v1.56h.05c.48-.9 1.63-1.85 3.36-1.85 3.6 0 4.26 2.37 4.26 5.45v6.29zM5.34 7.43c-1.14 0-2.06-.92-2.06-2.06s.92-2.06 2.06-2.06 2.06.92 2.06 2.06-.92 2.06-2.06 2.06zm1.78 13.02H3.55V9h3.57v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.55C0 23.23.79 24 1.77 24h20.45C23.2 24 24 23.23 24 22.27V1.72C24 .77 23.2 0 22.22 0z" })
                                ])
                            ]),
                            _createElementVNode("div", { class: "skeleton__head" }, [
                                _createElementVNode("span", { class: "skeleton__avatar skeleton__avatar--square" }),
                                _createElementVNode("span", { class: "skeleton__lines" }, [
                                    _createElementVNode("span", { class: "bar bar--short" }),
                                    _createElementVNode("span", { class: "bar bar--xshort" })
                                ])
                            ]),
                            _createElementVNode("div", { class: "skeleton__post" }, [
                                _createElementVNode("span", { class: "bar" }),
                                _createElementVNode("span", { class: "bar bar--mid" })
                            ]),
                            _createElementVNode("div", { class: "skeleton__media skeleton__media--small" })
                        ], -1),
                        _createElementVNode("div", { class: "skeleton skeleton--tt" }, [
                            _createElementVNode("span", { class: "skeleton__logo" }, [
                                _createElementVNode("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                    "aria-hidden": "true"
                                }, [
                                    _createElementVNode("path", { d: "M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.93a8.16 8.16 0 0 0 4.77 1.52V7.05a4.85 4.85 0 0 1-1.84-.36z" })
                                ])
                            ]),
                            _createElementVNode("div", { class: "skeleton__video" }, [
                                _createElementVNode("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                    "aria-hidden": "true"
                                }, [
                                    _createElementVNode("polygon", { points: "6 4 20 12 6 20 6 4" })
                                ])
                            ]),
                            _createElementVNode("div", { class: "skeleton__foot" }, [
                                _createElementVNode("span", { class: "bar bar--mid" }),
                                _createElementVNode("span", { class: "bar bar--xshort" })
                            ])
                        ], -1)
                    ]))], 2)
            ]),
            _: 1
        }, 8, ["tag", "title-pre", "title-italic", "title-post", "intro", "body", "stat", "stat-label"]),
        _createVNode(_component_ServicePair, {
            id: "services-ugc",
            tag: _ctx.$t('services.ugc.tag'),
            "title-pre": _ctx.$t('services.ugc.titlePre'),
            "title-italic": _ctx.$t('services.ugc.titleItalic'),
            "title-post": _ctx.$t('services.ugc.titlePost'),
            intro: _ctx.$t('services.ugc.intro'),
            body: _ctx.$t('services.ugc.body'),
            stat: _ctx.$t('services.ugc.stat'),
            "stat-label": _ctx.$t('services.ugc.statLabel')
        }, {
            visual: _withCtx(() => [
                _createElementVNode("div", {
                    ref: "polaroidsHost",
                    class: _normalizeClass(["polaroids", { 'polaroids--unfolded': _ctx.polaroidsUnfolded }])
                }, [
                    _createElementVNode("figure", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("img", {
                                src: _ctx.polaroid1,
                                alt: "",
                                "aria-hidden": "true"
                            }, null, 8, _hoisted_6)
                        ])
                    ]),
                    _createElementVNode("figure", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("img", {
                                src: _ctx.polaroid2,
                                alt: "",
                                "aria-hidden": "true"
                            }, null, 8, _hoisted_9)
                        ])
                    ]),
                    _createElementVNode("figure", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("img", {
                                src: _ctx.polaroid3,
                                alt: "",
                                "aria-hidden": "true"
                            }, null, 8, _hoisted_12)
                        ])
                    ])
                ], 2)
            ]),
            _: 1
        }, 8, ["tag", "title-pre", "title-italic", "title-post", "intro", "body", "stat", "stat-label"])
    ]));
}
